// extracted by mini-css-extract-plugin
export default {"containerData":"DynamicPermissions_containerData__gOfrx","permissionItem":"DynamicPermissions_permissionItem__ea+XH","listType":"DynamicPermissions_listType__c30fe"};